import { Expose } from '@nts/std/serialization';
import { Filter } from "../find-options/filter";
import { FilterInterface } from '@nts/std/interfaces';
import { WhereInterface } from '@nts/std/interfaces';
import { WhereOperators } from '@nts/std/types';

export class Where implements WhereInterface {

    constructor(){
        this.filter = new Filter();
    }

    @Expose()
    position: number;

    @Expose()
    operator: WhereOperators;

    @Expose()
    filter: FilterInterface;
}
